import DefaultTemplate from './DefaultTemplate';

// Same layout as Default; OTP flow is enabled via activeTemplate === 'otp' in HeroSection
const OtpTemplate = () => <DefaultTemplate />;

export default OtpTemplate;
